import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalController } from '@ionic/angular';
import { SharedService } from 'src/app/services/shared.service';
import { OrderFiscalSwitchComponent } from 'src/app/orders/order-fiscal-switch/order-fiscal-switch.component';
import { CurrencyService } from 'src/app/services/currency.service';
import { NumpadComponent } from 'src/app/shared/numpad/numpad.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TerminalDataService } from '../services/terminal-data.service';
import { PrinterService } from 'src/app/shared/printer/printer.service';

const PAYMENT_TYPE_CARD = 'card';
const PAYMENT_TYPE_CASH = 'cash';

@Component({
  templateUrl: './payment-dialog.component.html',
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentDialogComponent implements OnInit {
  numpudConfig: any = {};
  paymentType: 'cash' | 'card' | 'bonuses' = 'cash';
  amount: string;
  discountAmount: string;
  discountSubTitle: string;
  discountCond: string;
  futureBonusesAmount: string;
  chipsTotal: number;
  sourceSum = 0;

  fiscalOperationInProgress = false;

  fiscalCardPayments = false;
  customerBonuses = 0;

  get hasBonuses(): boolean {
    return this.customerBonuses > 0;
  }
  orgName: string;
  registerLabel: string;
  registerAddress: string;
  paymentMethods: any[] = [];
  paymentMethod: {
    paymenttype: 'cash' | 'card';
    name: string;
    instruction: string;
  };

  isPortretView = false;
  @ViewChild('fiscalSwitch') fiscalSwitch: OrderFiscalSwitchComponent;
  printReceipt = true;
  displayPrintToggle = false;
  terminalPaymentProgress: number = 0;
  @ViewChild('nampad') nampad: NumpadComponent;
  isBankTerminalPayment = false;
  orderCustomer: any;
  private _customerSub: Subscription;
  customerLoading = false;
  customerLoadingError = false;
  currency: string;
  payBonusesAmount = '0';
  hasCahsDrawer = false;
  focusedInput: 'cashInput' | 'cashbeck' | 'paymentAmount' = 'cashInput';
  cashbackColor = 'default';
  providedColor = 'default';
  amountColor = 'default';

  cashbackInvalid = false;
  providedInvalid = false;

  get orderAmount() {
    const _orderAmount = this.paymentForm.get('orderAmount').value;
    return this._currency.formatMoney(_orderAmount);
  }

  get paymentAmount() {
    const _paymentAmount = this.paymentForm.get('paymentAmount').value;
    return this._currency.formatMoney(_paymentAmount);
  }

  get providedAmount() {
    const _providedAmount = this.paymentForm.get('providedAmount').value;
    return this._currency.formatMoney(_providedAmount);
  }

  get _providedAmount(): string {
    const _providedAmount = this.paymentForm.get('providedAmount').value;
    if (!_providedAmount) {
      return '';
    } else {
      return _providedAmount;
    }
  }

  get remainsAmount() {
    const _remainsAmount = this.paymentForm.get('remainsAmount').value;
    return this._currency.formatMoney(_remainsAmount);
  }

  get paidAmount() {
    if (this.paymentData?.paidAmount > 0) {
      return this._currency.formatMoney(this.paymentData.paidAmount);
    }
    return '';
  }

  private _totalAmount: number;
  get totalAmount() {
    return this._currency.formatMoney(this._totalAmount);
  }

  paymentForm = new FormGroup({
    orderAmount: new FormControl(null),
    paymentAmount: new FormControl(null, Validators.required),
    providedAmount: new FormControl(null),
    remainsAmount: new FormControl(null),
    paymentMethod: new FormControl(null),
    paymentForm: new FormControl(null),
    isFiscalCheck: new FormControl(true),
    taxRegister: new FormControl(null),
  });

  paymentData: {
    orderAmount: number;
    paidAmount: number;
    hasPartialPayment: boolean;
    storeId: number;
  };
  hasPartialPayment = false;
  storeId: number;

  constructor(
    private _modalCtrl: ModalController,
    private shared: SharedService,
    private _currency: CurrencyService,
    private terminalDataService: TerminalDataService,
    private printerService: PrinterService,
    private _cd: ChangeDetectorRef
  ) {
    this.currency = this._currency.symbol;
    this.numpudConfig = {
      width: '300',
      height: '60',
      preselectBtns: ['100', '200', '500'],
      divisible: true,
    };
  }
  loading = false;

  async ngOnInit() {
    if (this.paymentData) {
      if (this.paymentData.orderAmount > 0 && this.paymentData.paidAmount > 0) {
        this._totalAmount =
          this.paymentData.orderAmount - this.paymentData.paidAmount;
      } else {
        this._totalAmount = this.paymentData.orderAmount;
      }

      this.hasPartialPayment = this.paymentData.hasPartialPayment;
      let paymentAmount = this.paymentData.orderAmount;
      if (this.paymentData.paidAmount > 0) {
        paymentAmount =
          this.paymentData.orderAmount - this.paymentData.paidAmount;
      }

      this.paymentForm.patchValue({
        orderAmount: this.paymentData.orderAmount,
        paymentAmount: paymentAmount,
        providedAmount: null,
        remainsAmount: null,
        paymentMethod: null,
        paymentForm: this.paymentType,
      });
    }

    this.storeId = this.paymentData.storeId;
    const settings = this.terminalDataService.terminalSettings();
    this.paymentMethods = settings.payment_methods;
    this.hasCahsDrawer = this.printerService.hasCashDrawer;
    this._cd.detectChanges();
  }

  private _updateProvidedAmount(amount: string) {
    this.paymentForm.get('providedAmount').setValue(amount);
    const _paymentAmountVal = this.paymentForm.get('paymentAmount').value;
    const _providedAmount = +amount || 0;
    this.providedColor = 'default';

    if (_providedAmount > 0) {
      let remains = 0;
      if (this.paymentData.hasPartialPayment) {
        const _paymentAmount = +_paymentAmountVal || 0;
        remains = _providedAmount - _paymentAmount;
      } else {
        remains = _providedAmount - this._totalAmount;
      }

      if (remains < 0) {
        this.providedColor = 'danger';
        this.paymentForm.get('remainsAmount').setValue(null);
        this.paymentForm.get('remainsAmount').setErrors({ invalid: true });
      } else {
        this.paymentForm.get('remainsAmount').setValue(remains);
        this.paymentForm.get('remainsAmount').setErrors(null);
      }
    } else {
      this.paymentForm.get('remainsAmount').setValue(null);
      this.paymentForm.get('remainsAmount').setErrors(null);
    }
    this._cd.detectChanges();
  }

  private _updatePaymentAmount(amount: string) {
    this.paymentForm.get('paymentAmount').setValue(amount);
    const _providedAmountVal = this.paymentForm.get('providedAmount').value;
    const _paymentAmount = +amount || 0;
    const _providedAmount = +_providedAmountVal || 0;
    const remains = _providedAmount - _paymentAmount;

    this.amountColor = 'default';
    this.providedColor = 'default';

    if (!_paymentAmount || _paymentAmount > this._totalAmount) {
      this.amountColor = 'danger';
    }

    if (_providedAmount < _paymentAmount) {
      this.providedColor = 'danger';
    }

    if (remains > 0) {
      this.paymentForm.get('remainsAmount').setValue(remains);
    } else {
      this.paymentForm.get('remainsAmount').setValue(null);
    }
    this._cd.detectChanges();
  }

  openCashDrawer() {
    this.printerService.openCashDrawer();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.isPortretView = window.innerWidth < 720;
    }, 500);
  }

  togglePrintReceipt(event: any) {
    this.printReceipt = event.detail.checked;
  }

  numpadInput(cash: string) {
    if (this.focusedInput == 'cashbeck') {
      this.cashbackInvalid = false;
      this.cashbackColor = 'default';
      this.payBonusesAmount = cash;

      if (+cash > this.customerBonuses) {
        this.cashbackColor = 'danger';
        this.cashbackInvalid = true;
        return;
      }
    }

    if (this.focusedInput == 'cashInput') {
      this.providedColor = 'default';
      this.providedInvalid = false;

      if (this.paymentType == 'card') {
        return;
      }

      this._updateProvidedAmount(cash);
    }

    if (this.focusedInput == 'paymentAmount') {
      this._updatePaymentAmount(cash);
    }
  }

  async pay() {
    if (this.paymentForm.invalid) {
      if (this.paymentForm.controls['paymentAmount'].invalid) {
        this.amountColor = 'danger';
      }
      this.shared.showErrorToast('Виправте помилки при оплаті', 3, 'bottom');
      return;
    }

    const model = this.paymentForm.getRawValue();
    model.isFiscalCheck = this.fiscalSwitch.isFiscalCheck;
    this._modalCtrl.dismiss(model);
  }

  getPaymentMethodName() {
    if (!this.paymentMethod) {
      return '';
    }

    if (this.paymentMethod.paymenttype == PAYMENT_TYPE_CASH) {
      return 'ГОТІВКА';
    }

    if (this.paymentMethod.paymenttype == PAYMENT_TYPE_CARD) {
      return 'БЕЗГОТІВКОВА';
    }

    return '';
  }

  selectPaymentMethod(method: {
    paymenttype: 'cash' | 'card';
    name: string;
    instruction: string;
  }) {
    this.paymentMethod = method;
    this.paymentForm.get('paymentForm').setValue(method.paymenttype);
    this.paymentForm.get('paymentMethod').setValue(method);

    if (method.paymenttype.toLocaleLowerCase() == PAYMENT_TYPE_CASH) {
      this.selectPaymentType(PAYMENT_TYPE_CASH);
    }

    if (method.paymenttype.toLocaleLowerCase() == PAYMENT_TYPE_CARD) {
      this.selectPaymentType(PAYMENT_TYPE_CARD);
    }
  }

  clearPaymentMethod() {
    this.paymentMethod = null;
    this.paymentForm.get('paymentMethod').setValue(null);

    this.selectPaymentType(PAYMENT_TYPE_CASH);
  }

  getFill(paymentType: 'cash' | 'card' | 'bonuses') {
    if (this.paymentType == paymentType) {
      return 'solid';
    } else {
      return 'outline';
    }
  }

  selectPaymentType(paymentType: 'cash' | 'card' | 'bonuses') {
    this.paymentType = paymentType;
    this.paymentForm.get('paymentForm').setValue(paymentType);
  }

  getPaymentName() {
    if (this.paymentMethod) {
      return this.paymentMethod.name;
    }

    if (this.paymentType == PAYMENT_TYPE_CARD) {
      return 'БЕЗГОТІВКОВА';
    }

    if (this.paymentType == PAYMENT_TYPE_CASH) {
      return 'ГОТІВКА';
    }

    return '';
  }

  focusCashbeck(inputName: 'cashInput' | 'cashbeck' | 'paymentAmount') {
    this.focusedInput = inputName;

    if (this.focusedInput == 'cashInput') {
      this.nampad.initialValue(this._providedAmount);
    } else if (this.focusedInput == 'cashbeck') {
      this.nampad.initialValue(this.payBonusesAmount);
    } else if (this.focusedInput == 'paymentAmount') {
      this.nampad.initialValue(this.paymentAmount);
    } else {
      this.nampad.initialValue(null);
    }
    this.nampad.initialValue(null);
  }

  close() {
    this.selectPaymentType(undefined);
    this._modalCtrl.dismiss();
  }

  ngOnDestroy() {
    if (this._customerSub) {
      this._customerSub.unsubscribe();
    }
  }
}
